import React from 'react';
import Badge from 'react-bootstrap/Badge';

export default function EnvironmentBadge(): React.ReactElement | null {
  const env = import.meta.env.VITE_ENVIRONMENT;
  switch (env) {
    case 'dev':
      return <Badge bg="info">DEV</Badge>;
    case 'staging':
      return <Badge bg="success">STAGING</Badge>;
    case 'test':
      return <Badge bg="warning">TESTING</Badge>;
    default:
      return null;
  }
}
